<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<div class="partner-home">
  <!-- Card 3745 (opção A do protótipo "inicio-do-parceiro-redesenho-visual-card-3745"): saudação e o
       resultado financeiro numa faixa navy no topo. -->
  <header class="ph-hero">
    <div class="ph-hero__head">
      <div>
        <h1 class="ph-hero__title">{{ greeting() }}</h1>
        <p class="ph-hero__subtitle">Acompanhe seus deals e o que depende de você.</p>
      </div>
      <app-button
        label="Registrar deal"
        icon="pi pi-plus"
        [theme]="'soft-rounded'"
        [size]="'medium'"
        [noMargin]="true"
        routerLink="/dashboard/commercial/register-deal" />
    </div>

    <!-- Card 3707: volume das captações e fee estimado, calculados no backend (GET partners/me/earnings). -->
    @if (showEarnings()) {
      <div class="ph-hero__earnings">
        <div class="ph-earning">
          <span class="ph-earning__label"><i class="pi pi-chart-line"></i>Volume em captação</span>
          @for (item of earnings().volume; track item.currency; let first = $first) {
            @if (first) {
              <span class="ph-earning__value"
                >{{ item.currency }} {{ item.total | vaultFormatCurrency: 2 }}</span
              >
            } @else {
              <span class="ph-earning__meta"
                >+ {{ item.currency }} {{ item.total | vaultFormatCurrency: 2 }}</span
              >
            }
          } @empty {
            <span class="ph-earning__value">BRL 0,00</span>
          }
          <span class="ph-earning__meta">soma do valor pretendido dos deals ativos</span>
        </div>
        <a class="ph-earning ph-earning--link" routerLink="/dashboard/commercial/calculator">
          <span class="ph-earning__label">
            <i class="pi pi-wallet"></i>Fee estimado
            <span class="ph-earning__cta">Abrir calculadora <i class="pi pi-arrow-right"></i></span>
          </span>
          @for (item of earnings().estimatedFee; track item.currency; let first = $first) {
            @if (first) {
              <span class="ph-earning__value ph-earning__value--money">
                {{ item.currency }} {{ item.total | vaultFormatCurrency: 2 }}
              </span>
            } @else {
              <span class="ph-earning__meta"
                >+ {{ item.currency }} {{ item.total | vaultFormatCurrency: 2 }}</span
              >
            }
          } @empty {
            <span class="ph-earning__value ph-earning__value--money">BRL 0,00</span>
          }
          <span class="ph-earning__meta" [class.ph-earning__meta--warn]="earningsFailed()">{{
            feeLabel()
          }}</span>
        </a>
      </div>
    }
  </header>

  @if (loading()) {
    <div class="partner-home__stats" aria-busy="true">
      @for (item of [1, 2, 3, 4]; track item) {
        <div class="ph-skeleton ph-skeleton--stat"></div>
      }
    </div>
    <div class="partner-home__grid">
      <div class="ph-skeleton ph-skeleton--panel"></div>
      <div class="ph-skeleton ph-skeleton--panel"></div>
    </div>
  } @else if (failed()) {
    <section class="ph-card ph-state">
      <i class="pi pi-cloud ph-state__icon ph-state__icon--error"></i>
      <h2 class="ph-state__title">Não deu para carregar o resumo dos seus deals</h2>
      <p class="ph-state__text">
        Os seus deals continuam lá. Use Tentar de novo em instantes, ou abra direto o board de Meus
        deals.
      </p>
      <div class="ph-state__actions">
        <app-button
          label="Tentar de novo"
          icon="pi pi-refresh"
          [noMargin]="true"
          (sendButtonClick)="retry()" />
        <app-button
          label="Abrir Meus deals"
          [theme]="'outline-grey'"
          [noMargin]="true"
          routerLink="/dashboard/commercial/my-deals" />
      </div>
    </section>
  } @else if (!hasDeals()) {
    <section class="ph-card ph-state">
      <i class="pi pi-briefcase ph-state__icon"></i>
      <h2 class="ph-state__title">Você ainda não tem deals</h2>
      <p class="ph-state__text">
        Registre o CNPJ de um cliente para reservá-lo no seu nome. A partir daí, o andamento e o que
        depende de você aparecem aqui.
      </p>
      <div class="ph-state__actions">
        <app-button
          label="Registrar deal"
          icon="pi pi-plus"
          [noMargin]="true"
          routerLink="/dashboard/commercial/register-deal" />
      </div>
    </section>
  } @else {
    <section class="ph-stats">
      <a class="ph-stat" routerLink="/dashboard/commercial/my-deals">
        <span class="ph-stat__icon"><i class="pi pi-briefcase"></i></span>
        <span class="ph-stat__body">
          <span class="ph-stat__label">Deals ativos</span>
          <span class="ph-stat__value">{{ summary().activeCount }}</span>
          <span class="ph-stat__meta">{{ totalLabel() }}</span>
        </span>
      </a>
      <div class="ph-stat">
        <span class="ph-stat__icon ph-stat__icon--warn"><i class="pi pi-bell"></i></span>
        <span class="ph-stat__body">
          <span class="ph-stat__label">Dependem de você</span>
          <span class="ph-stat__value" [class.ph-stat__value--warn]="summary().pendingCount > 0">
            {{ summary().pendingCount }}
          </span>
          <span class="ph-stat__meta">
            {{ summary().pendingCount ? 'veja a lista abaixo' : 'nada pendente agora' }}
          </span>
        </span>
      </div>
      <div class="ph-stat">
        <span class="ph-stat__icon"><i class="pi pi-shield"></i></span>
        <span class="ph-stat__body">
          <span class="ph-stat__label">Reservas de CNPJ ativas</span>
          <span class="ph-stat__value">{{ summary().activeReservations }}</span>
          <span
            class="ph-stat__meta"
            [class.ph-stat__meta--warn]="summary().expiringReservations > 0">
            @if (summary().expiringReservations === 1) {
              1 vence em até 20 dias
            } @else if (summary().expiringReservations > 1) {
              {{ summary().expiringReservations }} vencem em até 20 dias
            } @else {
              90 dias por CNPJ
            }
          </span>
        </span>
      </div>
      <div class="ph-stat">
        <span class="ph-stat__icon ph-stat__icon--ok"><i class="pi pi-users"></i></span>
        <span class="ph-stat__body">
          <span class="ph-stat__label">Com a Legatus</span>
          <span class="ph-stat__value">{{ summary().withLegatusCount }}</span>
          <span class="ph-stat__meta">deals ativos sem ação sua</span>
        </span>
      </div>
    </section>

    <div class="partner-home__grid">
      <section class="ph-card ph-panel">
        <div class="ph-panel__head">
          <h2 class="ph-panel__title">O que depende de você agora</h2>
          <span class="ph-panel__hint">
            {{ pendingItems().length }}
            {{ pendingItems().length === 1 ? 'pendência' : 'pendências' }}, por urgência
          </span>
        </div>

        @if (pendingItems().length === 0) {
          <p class="ph-panel__empty">
            Nada depende de você agora. As etapas em andamento estão com a Legatus ou com os
            clientes.
          </p>
        } @else {
          <ul class="ph-pending">
            @for (item of pendingItems(); track item.dealId + item.action) {
              <li>
                <a
                  class="ph-pending__item"
                  [ngClass]="'ph-pending__item--' + item.urgency"
                  [routerLink]="['/dashboard/commercial/my-deals', item.dealId]">
                  <span class="ph-pending__bar"></span>
                  <span class="ph-pending__body">
                    <span class="ph-pending__company">{{ item.corporateName }}</span>
                    <span class="ph-pending__action">{{ item.action }}</span>
                    @if (item.detail) {
                      <span class="ph-pending__detail">{{ item.detail }}</span>
                    }
                  </span>
                  <span class="ph-pending__cta">
                    {{ item.cta }}
                    <i class="pi pi-arrow-right"></i>
                  </span>
                </a>
              </li>
            }
          </ul>
        }
      </section>

      <section class="ph-card ph-panel">
        <div class="ph-panel__head">
          <h2 class="ph-panel__title">Seu funil</h2>
          <a class="ph-panel__link" routerLink="/dashboard/commercial/my-deals"
            >Abrir Meus deals <i class="pi pi-arrow-right"></i
          ></a>
        </div>
        <ul class="ph-funnel">
          @for (bar of funnel(); track bar.stage) {
            <li class="ph-funnel__row" [class.ph-funnel__row--zero]="!bar.count">
              <span class="ph-funnel__label">{{ bar.label }}</span>
              <span class="ph-funnel__track">
                @if (bar.count) {
                  <span class="ph-funnel__bar" [style.width.%]="bar.percent"></span>
                }
              </span>
              <span class="ph-funnel__count">{{ bar.count }}</span>
            </li>
          }
        </ul>
        <p class="ph-panel__note">Mesmas etapas e mesma contagem do board de Meus deals.</p>
      </section>
    </div>

    <!-- Seus deals (card 3558): todos os deals, inclusive os rejeitados, em Deal › etapa › situação. -->
    <section class="ph-card ph-panel">
      <div class="ph-panel__head ph-panel__head--wrap">
        <h2 class="ph-panel__title">Seus deals</h2>
        <div class="ph-filter" role="tablist" aria-label="Filtrar deals">
          @for (option of dealFilters; track option.value) {
            <button
              type="button"
              role="tab"
              class="ph-filter__option"
              [class.is-active]="dealFilter() === option.value"
              [attr.aria-selected]="dealFilter() === option.value"
              (click)="dealFilter.set(option.value)">
              {{ option.label }} <span class="ph-filter__count">{{ dealCount(option.value) }}</span>
            </button>
          }
        </div>
      </div>

      @if (dealRows().length === 0) {
        <p class="ph-panel__empty">
          {{
            dealFilter() === 'rejected'
              ? 'Nenhum deal rejeitado.'
              : 'Nenhum deal em andamento agora.'
          }}
        </p>
      } @else {
        <ul class="ph-deals">
          <li class="ph-deals__header" aria-hidden="true">
            <span>Empresa</span>
            <span>Etapa</span>
            <span>Situação</span>
            <span class="ph-deals__header-amount">Valor pretendido</span>
          </li>
          @for (row of dealRows(); track row.dealId) {
            <li>
              <a
                class="ph-deals__item"
                [class.ph-deals__item--rejected]="row.rejected"
                [routerLink]="['/dashboard/commercial/my-deals', row.dealId]">
                <span class="ph-deals__company" [title]="row.corporateName">
                  {{ row.corporateName }}
                </span>
                <span class="ph-deals__stage">
                  <i class="pi pi-angle-right" aria-hidden="true"></i>
                  {{ row.stageLabel }}
                </span>
                <span class="ph-deals__status" [class.ph-deals__status--rejected]="row.rejected">
                  {{ row.status }}
                  @if (row.rejectedAt) {
                    <span class="ph-deals__date">em {{ row.rejectedAt | vaultDateTime }}</span>
                  }
                </span>
                <span class="ph-deals__amount">
                  {{ row.amount | currency: row.currencyCode : 'symbol' : '1.0-0' : 'pt-BR' }}
                </span>
              </a>
            </li>
          }
        </ul>
      }
    </section>
  }
</div>
